import {select, take, put} from 'redux-saga/effects';
import {matchPath} from '@computerrock/formation-router';
import {persistenceStates} from '@computerrock/formation-core';
import routePaths from '../../routePaths';
import scOverviewScreenTabs from '../../service-cases/scOverviewScreenTabs';
import invoiceOverviewScreenTabs from '../../invoices/invoiceOverviewScreenTabs';
import * as invoiceActionTypes from '../../invoices/invoiceActionTypes';
import * as taskActionTypes from '../../tasks/taskActionTypes';
import * as serviceCaseActionTypes from '../../service-cases/serviceCaseActionTypes';
import * as communicationActionTypes from '../../communication/communicationActionTypes';
import modalIds from '../../modalIds';

const resetListResults = function* resetListResults() {
    while (true) {
        const {payload} = yield take('@@router/LOCATION_CHANGE');
        const {previousLocation} = yield select(state => state.application);
        const {state} = payload.location;

        if (!previousLocation) continue;

        const searchParams = previousLocation?.search
            ? new URLSearchParams(previousLocation.search)
            : null;
        const activeTab = searchParams ? searchParams.get('activeTab') : '';

        const listScreenMatch = [
            routePaths.INVOICES_SEARCH,
            routePaths.SERVICE_CASES_SEARCH,
            routePaths.TASKS_SEARCH,
            routePaths.SERVICE_CASES_OVERVIEW,
            routePaths.INVOICE_OVERVIEW,
        ].find(path => (
            matchPath(previousLocation.pathname, {path, exact: true})
            && ((path !== routePaths.SERVICE_CASES_OVERVIEW
                    && path !== routePaths.INVOICE_OVERVIEW)
                || (path === routePaths.SERVICE_CASES_OVERVIEW
                    && (activeTab === scOverviewScreenTabs.TASKS
                        || activeTab === scOverviewScreenTabs.DOCUMENT
                        || activeTab === scOverviewScreenTabs.COMMUNICATION))
                || (path === routePaths.INVOICE_OVERVIEW
                    && (activeTab === invoiceOverviewScreenTabs.TASKS
                    || activeTab === invoiceOverviewScreenTabs.COMMUNICATION)))
        ));

        if (!listScreenMatch) continue;

        switch (listScreenMatch) {
            case routePaths.INVOICES_SEARCH: {
                yield put({
                    type: invoiceActionTypes.STORE_INVOICES_SEARCH_RESULTS,
                    payload: {
                        invoiceDTOs: [],
                        totalCount: 0,
                        persistenceState: persistenceStates.PENDING,
                        isError: false,
                    },
                });
                break;
            }

            case routePaths.SERVICE_CASES_SEARCH: {
                yield put({
                    type: serviceCaseActionTypes.STORE_SERVICE_CASE_SEARCH_RESULTS,
                    payload: {
                        serviceCaseDTOs: [],
                        totalCount: 0,
                        persistenceState: persistenceStates.PENDING,
                        isError: false,
                    },
                });
                break;
            }

            case routePaths.TASKS_SEARCH: {
                if (state?.isModalOpen && state?.modalId === modalIds.TASK_DATA_MODAL) break;
                yield put({
                    type: taskActionTypes.STORE_TASK_SEARCH_RESULTS,
                    payload: {
                        taskDTOs: [],
                        taskSearchResultsCount: 0,
                        persistenceState: persistenceStates.PENDING,
                        isError: false,
                    },
                });
                break;
            }

            case routePaths.SERVICE_CASES_OVERVIEW: {
                if (![
                    scOverviewScreenTabs.DOCUMENT,
                    scOverviewScreenTabs.COMMUNICATION,
                    scOverviewScreenTabs.TASKS,
                ].includes(activeTab)) return;
                if (activeTab === scOverviewScreenTabs.DOCUMENT) {
                    yield put({
                        type: serviceCaseActionTypes.STORE_SERVICE_CASE_DOCUMENTS,
                        payload: {
                            serviceCaseDocumentsDTOs: [],
                            persistenceState: persistenceStates.PENDING,
                            isError: false,
                        },
                    });
                    break;
                }
                if (activeTab === scOverviewScreenTabs.COMMUNICATION) {
                    yield put({
                        type: communicationActionTypes.RESET_MESSAGE_SEARCH_RESULTS,
                        payload: null,
                    });
                    yield put({
                        type: communicationActionTypes.SET_MESSAGE_SEARCH_PERSISTENCE_STATE,
                        payload: {newPersistenceState: persistenceStates.PENDING},
                    });
                    break;
                }
                if (state?.isModalOpen && state?.modalId === modalIds.TASK_DATA_MODAL) break;
                yield put({
                    type: taskActionTypes.STORE_TASK_SEARCH_RESULTS,
                    payload: {
                        taskDTOs: [],
                        taskSearchResultsCount: 0,
                        persistenceState: persistenceStates.PENDING,
                        isError: false,
                    },
                });
                break;
            }

            case routePaths.INVOICE_OVERVIEW: {
                if (![
                    invoiceOverviewScreenTabs.COMMUNICATION,
                    invoiceOverviewScreenTabs.TASKS,
                ].includes(activeTab)) return;
                if (activeTab === invoiceOverviewScreenTabs.COMMUNICATION) {
                    yield put({
                        type: communicationActionTypes.RESET_MESSAGE_SEARCH_RESULTS,
                        payload: null,
                    });
                    yield put({
                        type: communicationActionTypes.SET_MESSAGE_SEARCH_PERSISTENCE_STATE,
                        payload: {newPersistenceState: persistenceStates.PENDING},
                    });
                    break;
                }
                if (state?.isModalOpen && state?.modalId === modalIds.TASK_DATA_MODAL) break;
                yield put({
                    type: taskActionTypes.STORE_TASK_SEARCH_RESULTS,
                    payload: {
                        taskDTOs: [],
                        taskSearchResultsCount: 0,
                        persistenceState: persistenceStates.PENDING,
                        isError: false,
                    },
                });
                break;
            }

            default:
        }
    }
};

export default resetListResults;
